import { createQuoteSlice } from 'common/stores/redux/Quote';

const contractorQuoteSlice = createQuoteSlice('contractorQuote');

export const {
    init,
    replace,
    resetPages,
    updateKeyValuePair,
    addComment,
    updateComment,
    addFolderAttachment,
    removeFolderAttachment,
    addPhoto,
    updateInstructions,
    updateSpecialInstructions,
    updateContact,
    addContact,
    removeContact,
    deleteContact,
} = contractorQuoteSlice.actions;

/**
 * Updates the client for an quote, fetching and applying client-specific settings
 * @type {import('@reduxjs/toolkit').AsyncThunk<any, number, {}>}
 */
export const updateClient = contractorQuoteSlice.thunks.updateClient;

export default contractorQuoteSlice.reducer;
